import { View, Text, Image } from "react-native";
import React from "react";
import { tutorial, width } from "../../imports";
import MyText from "../custom/MyText";
import BabyIcon from "../../assets/svg/BabyIcon";
import translate from "../../functions/translate";
import PersonIcon from "../../assets/svg/PersonIcon";
import ShareIcon from "../../assets/svg/ShareIcon";
import HeartIcon from "../../assets/svg/HeartIcon";
import { gray } from "../../colors";
import { Ionicons } from "@expo/vector-icons";

export default function TutorialHeader({
  image,
  title,
  age,
  publisherName,
  readTime,
  liked
}) {
  return (
    <View style={{ overflow: "hidden", paddingBottom: 5, marginBottom: 10 }}>
      <View
        style={{
          padding: 10,
          backgroundColor: "white",
          //marginBottom: 10,
          shadowColor: "#000",
          shadowOffset: { width: 1, height: 1 },
          shadowOpacity: 0.4,
          shadowRadius: 3,
          elevation: 5,
        }}
      >
        <View style={{ flexDirection: "row" }}>
          <View style={{ width: width / 3, height: width / 3 }}>
            <Image
              source={{ uri: image }}
              style={{
                width: width / 3,
                height: width / 3,
                overflow: "hidden",
              }}
              resizeMode="contain"
            />
          </View>
          <View style={{ paddingHorizontal: 10, width: (2 * width) / 3 }}>
            <View>
              <MyText style={{ flexWrap: "wrap", wordWrap: "break" }}>
                {title}
              </MyText>
            </View>
            <View style={{ height: 15 }}></View>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <View style={{ marginHorizontal: 2 }}>
                <BabyIcon />
              </View>
              <MyText style={{ marginHorizontal: 2 }}>
                {translate("ages")}
              </MyText>
              <MyText style={{ marginHorizontal: 2 }}>:</MyText>
              <MyText style={{ marginHorizontal: 2 }}>{`${age}`}</MyText>
              <MyText style={{ marginHorizontal: 2 }}>
                {translate("years")}
              </MyText>
            </View>
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            marginTop: 25,
            alignItems: "center",
            paddingHorizontal: 10,
          }}
        >
          <View style={{ marginHorizontal: 2, marginTop: -3 }}>
            <PersonIcon color="#545454" />
          </View>
          <MyText style={{ marginHorizontal: 2 }}>{translate("writer")}</MyText>
          <MyText style={{ marginHorizontal: 2 }}>:</MyText>
          <MyText style={{ marginHorizontal: 2 }}>{publisherName}</MyText>
          <View style={{ flex: 1 }}></View>
          {/* <View style={{ transform: [{ scale: 1.6 }], marginHorizontal: 15 }}>
          <ShareIcon />
        </View>
        <View style={{ transform: [{ scale: 1.6 }] }}>
          <HeartIcon />
        </View> */}
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Ionicons name="time-outline" size={24} color="black" />
            <MyText style={{ marginHorizontal: 5 }}>{`${readTime} ${translate(
              "minutes"
            )}`}</MyText>
          </View>
        </View>
      </View>
    </View>
  );
}
